import { difference } from '@df/util/fn/difference';
import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';

interface IDelta<T> {
    before: T | undefined;
    after: T | undefined;
    delta: Partial<T> | undefined;
}

export class DataChangeEvent<T> {
    /**
     * Changes cache
     */
    private cache: { [key: string]: any } = {};

    /**
     *
     * @param before Data object before the change
     * @param after Data object after the change
     */
    constructor(
        public before: T | undefined,
        public after: T | undefined
    ) {}

    /**
     * Checks if given path was changed
     */
    isChanged(path: string): boolean {
        return !!this.getChange(path).delta;
    }

    /**
     * Gets information about changes in the object
     */
    getChange<T>(path: string = '') {
        if (this.cache[path] === undefined) {
            const a = path ? get(this.before, path) : this.before;
            const b = path ? get(this.after, path) : this.after;
            const delta = difference(b, a);
            this.cache[path] = { before: a, after: b, delta: isEmpty(delta) ? undefined : delta };
        }
        return this.cache[path] as IDelta<T>;
    }

    /**
     * If we manipulate on data object we need to clear cache
     */
    resetCache(): void {
        this.cache = {};
    }
}
